import { AbstractSSORouterFilter } from '@zk/framework-vue';
import { getToken, isSamlLogoutInProgress } from 'common-module/src/util/auth';
import { exchangeTicketOfToken, exchangeTokenOfTicket } from '@/api/user';
import config from 'common-module/src/config';

export default class SSOLoginFilter extends AbstractSSORouterFilter {
  // SSO单点登录地址
  ssoLoginUrl = config.VUE_APP_SSO_URL;

  matches(to, from) {
    return super.matches(to, from) && to.meta?.share !== true;
  }

  order() {
    return super.order() + 4;
  }

  async exchangeTokenOfTicket(ticket) {
    try {
      const token = await exchangeTokenOfTicket(ticket);
      if (token) {
        return token;
      }
    } catch (e) {
      console.warn('换取token异常', e);
    }
    return null;
  }

  async exchangeTicketOfToken(token) {
    try {
      const ticket = await exchangeTicketOfToken(token);
      if (ticket) {
        return ticket;
      }
    } catch (e) {
      console.warn('换取ticket异常', e);
    }
    return null;
  }

  getToken (to) {
    const token = super.getToken(to);
    return token || getToken() || this.option.store.state.user.token;
  }

  setToken (token) {
    this.option.store.commit('user/SET_TOKEN', token);
  }

  toLogin(to, from, token) {
    return super.toLogin(to, from, token);
  }

  async validateToken (token) {
    const validateToken = super.validateToken(token);
    if (!validateToken) {
      return false;
    }
    const valid = await this.option.store.dispatch('user/validateToken', token);
    return valid || isSamlLogoutInProgress();
  }
}
